<template>
  <v-dialog v-model="showItemPopup" max-width="620">
    <v-card v-if="user">
      <div class="fdlg__head">
        <span class="view-avatar" aria-hidden="true">{{ initials }}</span>
        <div>
          <h2 class="fdlg__title">{{ userFullName }}</h2>
          <p class="fdlg__sub">{{ roleText }}<template v-if="user.isActive === 'Blocat'">, cont blocat</template></p>
        </div>
        <v-btn icon aria-label="Închide" @click="showItemPopup = false">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </div>
      <v-card-text class="fdlg__body">
        <section class="form-section">
          <dl class="facts">
            <dt>Login</dt>
            <dd>{{ user.user_name }}</dd>
            <dt>E-mail</dt>
            <dd>{{ email || "—" }}</dd>
            <dt>Telefon mobil</dt>
            <dd>{{ mobilePhone }}</dd>
            <dt>Telefon fix</dt>
            <dd>{{ fixPhone }}</dd>
          </dl>
        </section>
        <section class="form-section">
          <div class="form-section__label"><v-icon small>mdi-domain</v-icon>{{ departments.length > 1 ? "Departamente" : "Departament" }}</div>
          <ul class="view-depts">
            <li v-for="d in departments" :key="d.name">
              <span>{{ d.name }}</span>
              <span class="view-depts__tags">
                <span v-if="d.isPrimary && departments.length > 1" class="tag">principal</span>
                <span v-if="d.isSef" class="tag tag--sef">Șef</span>
              </span>
            </li>
            <li v-if="!departments.length">—</li>
          </ul>
        </section>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { roleLabel } from "@/config/roles";

export default {
  props: {
    user: Object,
  },
  data() {
    return {
      showItemPopup: false,
    };
  },
  computed: {
    userFullName() {
      return this.user ? `${this.user.first_name} ${this.user.last_name}` : "";
    },
    initials() {
      return this.user ? `${(this.user.first_name || " ")[0]}${(this.user.last_name || " ")[0]}`.toUpperCase() : "";
    },
    roleText() {
      return this.user && this.user.roleId ? roleLabel(this.user.roleId.role) : "";
    },
    email() {
      return this.user ? this.user.email : "";
    },
    mobilePhone() {
      return (this.user && this.user.telephone) || "Nu există";
    },
    fixPhone() {
      return (this.user && this.user.landline) || "Nu există";
    },
    departments() {
      if (!this.user) return [];
      if (Array.isArray(this.user.departments) && this.user.departments.length) return this.user.departments;
      return this.user.department ? [{ name: this.user.department, isPrimary: true, isSef: false }] : [];
    },
  },
  methods: {
    show() {
      this.showItemPopup = true;
    },
  },
};
</script>

<style scoped>
.view-avatar {
  display: grid;
  place-items: center;
  flex: none;
  width: 52px;
  height: 52px;
  border-radius: 50%;
  background: var(--leaf);
  color: var(--pine-900);
  font-family: var(--font-display);
  font-weight: 800;
  font-size: 1.2rem;
}
.facts {
  display: grid;
  grid-template-columns: 140px 1fr;
  gap: 10px 16px;
  margin: 4px 0 12px;
}
.facts dt {
  color: var(--ink-3);
}
.facts dd {
  margin: 0;
  font-weight: 600;
  word-break: break-word;
}
.view-depts {
  list-style: none;
  padding: 0;
  margin: 0 0 10px;
}
.view-depts li {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 0;
  font-weight: 600;
}
.view-depts li + li {
  border-top: 1px solid var(--line-soft);
}
.view-depts__tags {
  display: flex;
  gap: 6px;
}
.tag {
  padding: 2px 9px;
  border-radius: 999px;
  background: var(--slate-bg);
  color: var(--slate);
  font-size: 0.8rem;
  font-weight: 700;
  white-space: nowrap;
}
.tag--sef {
  background: var(--pine-900);
  color: var(--leaf);
}
</style>
